import { useEffect } from "react";
import { storeUTMParams } from "../../utils/hubspotUtils";
import {
  HUBSPOT_ID,
  PROD_ENV,
  PROD_HUBSPOT_ID
} from "../../utils/constants/appConstants";

const HubspotLoader = () => {
  const environment = process.env.REACT_APP_ENV;
  const hubspotId = environment === PROD_ENV ? PROD_HUBSPOT_ID : HUBSPOT_ID;
  storeUTMParams();
  useEffect(() => {
    if (!document.getElementById("hs-script-loader")) {
      const script = document.createElement("script");
      script.src = `//js-ap1.hs-scripts.com/${hubspotId}.js`;
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";
      document.body.appendChild(script);
    }
  }, []);

  return null;
};

export default HubspotLoader;
